import { render, staticRenderFns } from "./DispatchModal.vue?vue&type=template&id=6a7cafeb&scoped=true&"
import script from "./DispatchModal.vue?vue&type=script&lang=js&"
export * from "./DispatchModal.vue?vue&type=script&lang=js&"
import style0 from "./DispatchModal.vue?vue&type=style&index=0&id=6a7cafeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7cafeb",
  null
  
)

export default component.exports